import { Userpilot } from 'userpilot';

const isProdEnvironment = () => {
  const url = window.location.href;

  const nonProdEnvironments = ['-ops', '-dev', '-staging', '-demo', '-pmu'];

  return nonProdEnvironments.every((value) => !url.includes(value));
};

export const initializeUserPilot = (): void => {
  try {
    // Further domain configuration can be done in the user pilot dashboard UI
    const userpilotLicensekey = isProdEnvironment()
      ? 'NX-1c4ec162'
      : 'STG-NX-1c4ec162';
    Userpilot.initialize(userpilotLicensekey);
  } catch (error) {
    // Log the error without using console if there is an issue identifying the user but no need to throw an error as it should not affect user experience
    console.warn('Error initializing Userpilot', error);
  }
};
